@if (sessionQuery.user$ | async; as user) {
  <nz-descriptions>
    <nz-descriptions-item nzTitle="Логин">{{ user.login }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="ФИО">{{ user | shortName }}</nz-descriptions-item>
  </nz-descriptions>
}
<div class="modal-footer" *nzModalFooter></div>
